import $ from 'jquery';
import _ from 'underscore';

import StateManager from './scuba/StateManager';
import LayoutManager from './scuba/LayoutManager';
import HorizontalLayout from './scuba/HorizontalLayout';
import MobileLayout from './scuba/MobileLayout';

require('./scuba/Navigation');
require('./scuba/Content');
require('./scuba/ListForm');
require('./scuba/ListSnap');
require('./scuba/ListLazyLoading');
require('./scuba/Menu');

require('./components/Authors');
require('./components/Content');
require('./components/Gallery');
require('./components/Player');
require('./components/Posts');
require('./components/Topics');

// gestionnaire de layout
LayoutManager.setLayouts([
    new HorizontalLayout(),
    new MobileLayout(),
]);

// initialisation
$(document).ready(function() {
    var $body = $(document.body);
    var $wrap = $('.js-scuba__wrap').first();
    var $head = $('.js-scuba__head').first();
    var $main = $('.js-scuba__main').first();
    if (!$wrap.length) {
        $wrap = $('<div class="js-scuba__wrap"></div>').prependTo($body);
        $head.appendTo($wrap);
        $main.appendTo($wrap);
    }

    // $(window).on(StateManager.CONTENT_READY, function(event, node) {

    // });

    $(document).on('click', 'a', function(event) {
        // récupération du lien
        var $link = $(event.currentTarget);

        // récupération des informations
        var href = $link.attr('href');
        var target = $link.attr('target');
        var dataTarget = $link.attr('data-target');
        // var dataHeight = $link.attr('data-height') ||  ( parseInt( $(window).height() * 0.9 ) ) ;
        // var dataWidth = $link.attr('data-width') || Math.min ( parseInt( ( $(window).width() * 0.9 ) ) , 768 ) ;
        var callback = $link.attr('data-callback') || null ;

        // ouverture d'une page
        if (target === '_blank' || $link.parent().hasClass("c-scuba-menu__item--newsletter")) {
            // console.log('link:', '_blank');
            // on laisse passer le lien sans rien faire
        }

        // lien à gérer par un JS
        else if (href === '#') {
          if ( callback && ( callback != '' ) ) eval( callback ) ;
          event.preventDefault();
        }

        // liens de DGT NAV
        else if ( (dataTarget && (dataTarget !== 'cover')) || $link.closest('.js-scuba__nav').length ) {
            event.preventDefault();

            // récupère le page url pour retrouver le contexte en self ou after
            var pageUrl = $link.closest('.js-scuba__head,.js-scuba__page').data('url');

            // montre qu'on charge le lien
            $link.addClass('is-loading');

            StateManager.pushState(href, dataTarget, pageUrl)
            .fin(function() {
                // remet dans l'état normal
                $link.removeClass('is-loading');
            });
        }
    });

    $(document).on('click', '[data-target="after"]', function(event) {
      var $page = $(event.currentTarget).closest(".c-scuba-layout__page");
      $page.find(".c-scuba-layout__section").removeClass('is-active');
      var $activeSection = $(event.currentTarget).closest(".c-scuba-layout__section").addClass('is-active');
      var offset = 0;
      if($activeSection.hasClass('js-topics')){
        $activeSection = $activeSection.find(".js-topics__scroller");
        offset = -60;
      }
      $(window).one(StateManager.STATE_CHANGE, function(){
        $activeSection.animate({
          scrollTop: $(event.currentTarget).offset().top + $activeSection.scrollTop() + offset,
        });
      });
    });

    $(window).on(StateManager.CONTENT_READY, function(event, node) {
      $(node).find('.js-toggle-search').on('click', function(event) {
        event.preventDefault();
        $("body").addClass('is-transitioning-search');
        setTimeout(function(){
          $("body").removeClass('is-transitioning-search');
        }, 400);
        $("body").toggleClass('has-search-open');
        if($("body").hasClass('has-search-open')) {
          $(".js-search-input").first().focus();
        }
        $(node).find(".js-scuba__list").data('js-scuba__list').$viewport.trigger("scroll");
      });
    });

    $(window).on(StateManager.STATE_CHANGE, function(event, state){
      var lastPage = _.last(state);
      if (lastPage) {
        var $page = lastPage.$element;
        var url = $page.data('url') ;
        // condition for google tracking
        var isStats = (( typeof window._gaq != 'undefined' ) && ( url != null )) ;
        if ( isStats ){
          window._gaq.push(['_trackPageview'],url);
        }
      }
    });

    StateManager.init()
      .then(function() {
        LayoutManager.start()
          .then(function(){
            $(document.body).removeClass("is-loading")
          });
      })
      .fail(function(reason) {
        console.error(reason && reason.stack ? reason.stack : reason);
      });
});



// WEBPACK FOOTER //
// ./scripts/main.js